module.exports = __webpack_public_path__ + "static/media/pictureGallery.65df0bb5.svg";